import debounce from 'lodash-es/debounce';

const status = {
  debouncing: false,
};
const quantity_debouncers = {};
const quantities = {};

const plusMinusQuantity = (e, action) => {
  const quantityInput = e.currentTarget.closest('.quantity-container').querySelector('[data-quantity-input]');
  const debounce_key = quantityInput.dataset.quantityDebounce;
  let quantity = Number(quantityInput.value);
  console.log('quantityInput', quantityInput);
  if (action === 'plus') {
    quantity += 1;
  } else {
    quantity -= 1;

    if (quantity < Number(quantityInput.min)) {
      quantity = quantityInput.min;
    }
  }

  quantityInput.value = quantity;

  if (debounce_key) {
    quantities[debounce_key] = quantity;

    if (!quantity_debouncers[debounce_key]) {
      quantity_debouncers[debounce_key] = debounce(() => {
        // We set the value again to make sure it doesn't glitch if another AJAX request just completed
        document.querySelector(`[data-quantity-debounce="${debounce_key}"]`).value = quantities[debounce_key];
        document.querySelector(`[data-quantity-debounce="${debounce_key}"]`).dispatchEvent(new Event('change'));
        status.debouncing = false;
      }, 150);
    }

    quantity_debouncers[debounce_key]();
    status.debouncing = true;
  }
};

const plusQuantity = (e) => {
  plusMinusQuantity(e, 'plus');
};

const minusQuantity = (e) => {
  plusMinusQuantity(e, 'minus');
};

export { plusQuantity, minusQuantity, status };
